import * as COUNTRIES from './countries.json';

export const getCountryNameByCode = (code: string) => {
  return (COUNTRIES as any).default.find((item: any) => item.code === code)?.name;
};

export const getCountryCodeByName = (name: string) => {
  return (COUNTRIES as any).default.find((item: any) => item.name === name)?.code;
};
